<template>
  <div class="seckill-publish-container">
    <div class="main-content">
      <el-card shadow="never" class="table-card">
        <div slot="header" class="card-header">
          <div class="header-title">
            <i class="el-icon-date" /> 秒杀活动管理列表
          </div>
          <el-button type="primary" icon="el-icon-plus" size="small" @click="openCreateDialog">
            创建秒杀活动
          </el-button>
        </div>

        <!-- 列表表格 -->
        <el-table v-loading="listLoading" :data="activityList" border stripe style="width: 100%;">
          <el-table-column prop="id" label="活动ID" width="90" align="center" />
          <el-table-column prop="title" label="活动名称" min-width="180" show-overflow-tooltip />
          <el-table-column prop="startTime" label="开始时间" width="170" align="center" />
          <el-table-column prop="endTime" label="结束时间" width="170" align="center" />
          <el-table-column label="活动状态" width="110" align="center">
            <template slot-scope="scope">
              <el-tag :type="getStatusTagType(scope.row)" size="small" effect="plain">
                {{ getStatusText(scope.row) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="160" align="center">
            <template slot-scope="scope">
              <el-button type="text" size="small" class="action-btn" @click="warmup(scope.row)">
                <i class="el-icon-cpu" /> 预热缓存
              </el-button>
              <el-button type="text" size="small" class="action-btn" @click="viewDetail(scope.row)">
                详情
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-card>

      <!-- 发布秒杀活动 Dialog -->
      <el-dialog
        title="配置并发布秒杀活动"
        :visible.sync="publishDialogVisible"
        width="820px"
        top="6vh"
        :close-on-click-modal="false"
        @closed="resetPublishForm"
      >
        <el-form ref="formRef" :model="form" :rules="rules" label-width="110px" size="small">
          <div class="form-section-title">基本属性</div>
          <el-form-item label="活动名称" prop="title">
            <el-input v-model="form.title" placeholder="例如：双11高并发限时秒杀" style="width: 360px;" />
          </el-form-item>

          <el-form-item label="起止时间" prop="timeRange">
            <el-date-picker
              v-model="form.timeRange"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 360px;"
            />
          </el-form-item>

          <div class="form-section-header">
            <span class="form-section-title">参与商品配置</span>
            <el-button type="primary" icon="el-icon-plus" size="mini" plain @click="openGoodsSelectDialog">
              添加商品
            </el-button>
          </div>

          <!-- 已选商品编辑表格 -->
          <el-table :data="form.seckillGoodsList" border size="small" style="width: 100%; margin-top: 10px;" max-height="260px">
            <el-table-column label="商品" min-width="160">
              <template slot-scope="scope">
                <div class="goods-info-cell">
                  <img :src="scope.row.picUrl" class="cell-img">
                  <span class="cell-title">{{ scope.row.title }}</span>
                </div>
              </template>
            </el-table-column>

            <el-table-column prop="originalPrice" label="原价" width="90" align="center">
              <template slot-scope="scope">￥{{ scope.row.originalPrice }}</template>
            </el-table-column>

            <el-table-column label="秒杀价(元)" width="120" align="center">
              <template slot-scope="scope">
                <el-input-number
                  v-model="scope.row.seckillPrice"
                  :precision="2"
                  :step="1"
                  :min="0.01"
                  :max="Number(scope.row.originalPrice)"
                  controls-position="right"
                  style="width: 95px;"
                />
              </template>
            </el-table-column>

            <el-table-column label="秒杀库存" width="110" align="center">
              <template slot-scope="scope">
                <el-input-number
                  v-model="scope.row.seckillCount"
                  :min="1"
                  controls-position="right"
                  style="width: 85px;"
                />
              </template>
            </el-table-column>

            <el-table-column label="限购数" width="100" align="center">
              <template slot-scope="scope">
                <el-input-number
                  v-model="scope.row.seckillLimit"
                  :min="1"
                  :max="10"
                  controls-position="right"
                  style="width: 75px;"
                />
              </template>
            </el-table-column>

            <el-table-column label="操作" width="65" align="center">
              <template slot-scope="scope">
                <el-button type="text" style="color: #ef4444;" @click="removeGoods(scope.$index)">移除</el-button>
              </template>
            </el-table-column>
          </el-table>

          <div v-if="form.seckillGoodsList.length === 0" class="empty-goods-box">
            暂未选择任何秒杀商品，请点击右上角按钮添加
          </div>
        </el-form>

        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="publishDialogVisible = false">取消</el-button>
          <el-button size="small" type="primary" :loading="submitting" @click="submitForm">提交发布</el-button>
        </span>
      </el-dialog>

      <!-- 选择商品 Dialog -->
      <el-dialog title="选择商品" :visible.sync="goodsDialogVisible" width="680px" append-to-body center>
        <div class="filter-bar">
          <el-input v-model="searchKeyword" placeholder="检索商品名称" size="small" style="width: 240px;" clearable />
          <el-button type="primary" size="small" icon="el-icon-search" @click="fetchAvailableGoods">查询</el-button>
        </div>

        <el-table
          v-loading="goodsLoading"
          :data="availableGoods"
          border
          size="small"
          max-height="300px"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="45" align="center" />
          <el-table-column label="图片" width="65" align="center">
            <template slot-scope="scope">
              <img :src="scope.row.picUrl" width="36" height="36" style="border-radius: 4px; object-fit: cover;">
            </template>
          </el-table-column>
          <el-table-column prop="title" label="商品名称" show-overflow-tooltip />
          <el-table-column prop="price" label="原价" width="90" align="center">
            <template slot-scope="scope">￥{{ scope.row.price }}</template>
          </el-table-column>
          <el-table-column prop="stock" label="剩余库存" width="90" align="center" />
        </el-table>

        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="goodsDialogVisible = false">取消</el-button>
          <el-button size="small" type="primary" @click="confirmGoodsSelection">加入列表</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { getProducts, createSeckillActivity, getSeckillActivityList, warmupSeckill } from '@/api/mall'

export default {
  name: 'SeckillConfig',
  data() {
    return {
      listLoading: false,
      activityList: [],
      publishDialogVisible: false,
      submitting: false,
      form: {
        title: '',
        timeRange: [],
        seckillGoodsList: []
      },
      rules: {
        title: [{ required: true, message: '请输入活动名称', trigger: 'blur' }],
        timeRange: [{ required: true, message: '请选择时间范围', trigger: 'change' }]
      },
      goodsDialogVisible: false,
      goodsLoading: false,
      searchKeyword: '',
      availableGoods: [],
      selectedRows: []
    }
  },
  created() {
    this.fetchActivityList()
  },
  methods: {
    async fetchActivityList() {
      this.listLoading = true
      try {
        const resp = await getSeckillActivityList()
        if (resp.code === 0) {
          this.activityList = resp.data.list || resp.data || []
        }
      } catch (e) {
        this.$message.error('活动列表获取失败')
      } finally {
        this.listLoading = false
      }
    },
    openCreateDialog() {
      this.publishDialogVisible = true
    },
    resetPublishForm() {
      if (this.$refs.formRef) this.$refs.formRef.resetFields()
      this.form.seckillGoodsList = []
    },
    openGoodsSelectDialog() {
      this.goodsDialogVisible = true
      this.fetchAvailableGoods()
    },
    async fetchAvailableGoods() {
      this.goodsLoading = true
      try {
        const resp = await getProducts({ pn: 1, keyword: this.searchKeyword })
        if (resp.code === 0) {
          this.availableGoods = resp.data.list || resp.data || []
        }
      } finally {
        this.goodsLoading = false
      }
    },
    handleSelectionChange(val) {
      this.selectedRows = val
    },
    confirmGoodsSelection() {
      if (this.selectedRows.length === 0) {
        this.$message.warning('请至少勾选一款商品')
        return
      }
      this.selectedRows.forEach(goods => {
        const exists = this.form.seckillGoodsList.some(item => item.goodsId === goods.id)
        if (!exists) {
          this.form.seckillGoodsList.push({
            goodsId: goods.id,
            skuId: goods.skuId || goods.id,
            title: goods.title,
            picUrl: goods.picUrl,
            originalPrice: goods.price,
            seckillPrice: (goods.price * 0.5).toFixed(2),
            seckillCount: 100,
            seckillLimit: 1
          })
        }
      })
      this.goodsDialogVisible = false
    },
    removeGoods(index) {
      this.form.seckillGoodsList.splice(index, 1)
    },
    submitForm() {
      this.$refs.formRef.validate(async valid => {
        if (!valid) return
        if (this.form.seckillGoodsList.length === 0) {
          this.$message.warning('请至少指定一款秒杀商品！')
          return
        }
        const payload = {
          title: this.form.title,
          startTime: this.form.timeRange[0],
          endTime: this.form.timeRange[1],
          productList: this.form.seckillGoodsList.map(item => ({
            skuId: item.skuId,
            seckillPrice: item.seckillPrice,
            seckillStock: item.seckillCount,
            seckillLimit: item.seckillLimit
          }))
        }
        this.submitting = true
        try {
          const resp = await createSeckillActivity(payload)
          if (resp.code === 0) {
            this.$message.success('活动发布成功！')
            this.publishDialogVisible = false
            this.fetchActivityList()
          } else {
            this.$message.error(resp.msg || '发布失败')
          }
        } finally {
          this.submitting = false
        }
      })
    },
    getStatusText(row) {
      const now = new Date().getTime()
      const start = new Date(row.startTime).getTime()
      const end = new Date(row.endTime).getTime()
      if (now < start) return '未开始'
      if (now >= start && now <= end) return '进行中'
      return '已结束'
    },
    getStatusTagType(row) {
      const status = this.getStatusText(row)
      if (status === '进行中') return 'success'
      if (status === '未开始') return 'warning'
      return 'info'
    },
    warmup(row) {
      this.$confirm(`确定要把活动 [${row.title}] 预热写入 Redis 吗？`, '提示', { type: 'warning' })
        .then(() => {
          warmupSeckill({ seckillId: row.id || row.seckillId }).then(resp => {
            this.$message.success(resp.msg || 'Redis 预热成功！')
          })
        }).catch(() => {})
    },
    viewDetail(row) {
      this.$message.info(`查看活动 ID: ${row.id}`)
    }
  }
}
</script>

<style scoped>
.seckill-publish-container {
  padding: 24px;
  background-color: #f8fafc;
  min-height: 100vh;
}

.main-content {
  max-width: 1100px;
  margin: 0 auto;
}

.table-card {
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-title {
  font-size: 16px;
  font-weight: 700;
  color: #1e293b;
}

.form-section-title {
  font-size: 14px;
  font-weight: 600;
  color: #334155;
  border-left: 3px solid #3b82f6;
  padding-left: 8px;
  margin-bottom: 12px;
}

.form-section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 18px;
  margin-bottom: 8px;
}

.goods-info-cell {
  display: flex;
  align-items: center;
  gap: 8px;
}

.cell-img {
  width: 32px;
  height: 32px;
  border-radius: 4px;
  object-fit: cover;
}

.cell-title {
  font-size: 12px;
  color: #334155;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.empty-goods-box {
  text-align: center;
  color: #94a3b8;
  padding: 24px;
  background-color: #f8fafc;
  border: 1px dashed #cbd5e1;
  border-radius: 6px;
  margin-top: 12px;
  font-size: 13px;
}

.filter-bar {
  display: flex;
  gap: 10px;
  margin-bottom: 12px;
}

.action-btn {
  font-size: 12px;
}
</style>
